import React from "react";
import { Modal, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const style = {
  position: "block",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  border: "0px",
  borderRadius: "10px",
  p: 2,
};

const ContactModalComponent = ({ open, setOpen }) => {
  console.log("here");
  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      style={{ width: "50vw", top: "10%", left: "25%", overflow: "auto" }}
    >
      <Box sx={style}>
        <div
          style={{
            height: "10vh",
            backgroundColor: "#f15d30",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <h5 style={{ padding: 5, color: "white" }}>
            Tell us what you are looking for
          </h5>
          <CloseIcon
            style={{ color: "white", cursor: "pointer" }}
            onClick={() => setOpen(false)}
          />
        </div>
        <div>
          <h5>Leisure / Tailor Made</h5>
          <form>
            {/* 1 */}
            <div className="row mt-2">
              <div className="col-sm-4">
                <label style={{ padding: 0, margin: 0, color: "black" }}>
                  Name:
                </label>
                <input type="text" placeholder="Enter Name" />
              </div>
              <div className="col-sm-4">
                <label style={{ padding: 0, margin: 0, color: "black" }}>
                  Contact Number:
                </label>
                <input type="text" placeholder="Enter Contact Number" />
              </div>
              <div className="col-sm-4">
                <label style={{ padding: 0, margin: 0, color: "black" }}>
                  Email Id:
                </label>
                <input type="text" placeholder="Enter Email Id" />
              </div>
            </div>
            {/* 2 */}
            <div className="row mt-2">
              <div className="col-sm-3">
                <label style={{ padding: 0, margin: 0, color: "black" }}>
                  Country:
                </label>
                <select
                  name="Any Theme"
                  id="Any Theme"
                  style={{ width: "100%", height: "2em" }}
                >
                  <option value="beach">Sector</option>
                  <option value="saab">Saab</option>
                  <option value="opel">Opel</option>
                  <option value="audi">Audi</option>
                </select>
              </div>

              <div className="col-sm-3 ">
                <label style={{ padding: 0, margin: 0, color: "black" }}>
                  State:
                </label>
                <select
                  name="Any Theme"
                  id="Any Theme"
                  style={{ width: "100%", height: "2em" }}
                >
                  <option value="beach">Sector</option>
                  <option value="saab">Saab</option>
                  <option value="opel">Opel</option>
                  <option value="audi">Audi</option>
                </select>
              </div>
              <div className="col-sm-3">
                <label style={{ padding: 0, margin: 0, color: "black" }}>
                  City:
                </label>
                <select
                  name="Any Theme"
                  id="Any Theme"
                  style={{ width: "100%", height: "2em" }}
                >
                  <option value="beach">Sector</option>
                  <option value="saab">Saab</option>
                  <option value="opel">Opel</option>
                  <option value="audi">Audi</option>
                </select>
              </div>
              <div className="col-sm-3">
                <label style={{ padding: 0, margin: 0, color: "black" }}>
                  Profile:
                </label>
                <select
                  name="Any Theme"
                  id="Any Theme"
                  style={{ width: "100%", height: "2em" }}
                >
                  <option value="beach">Sector</option>
                  <option value="saab">Saab</option>
                  <option value="opel">Opel</option>
                  <option value="audi">Audi</option>
                </select>
              </div>
            </div>
            {/* 3 */}
            <div className="row mt-2">
              <div className="col-sm-4">
                <label style={{ padding: 0, margin: 0, color: "black" }}>
                  Query for:
                </label>
                <select
                  name="Any Theme"
                  id="Any Theme"
                  style={{ width: "100%", height: "2em" }}
                >
                  <option value="beach">Sector</option>
                  <option value="saab">Saab</option>
                  <option value="opel">Opel</option>
                  <option value="audi">Audi</option>
                </select>
              </div>

              <div className="col-sm-4">
                <label style={{ padding: 0, margin: 0, color: "black" }}>
                  Sector:
                </label>
                <select
                  name="Any Theme"
                  id="Any Theme"
                  style={{ width: "100%", height: "2em" }}
                >
                  <option value="beach">Sector</option>
                  <option value="saab">Saab</option>
                  <option value="opel">Opel</option>
                  <option value="audi">Audi</option>
                </select>
              </div>
              <div className="col-sm-4">
                <label style={{ padding: 0, margin: 0, color: "black" }}>
                  Other Sectors:
                </label>
                <input type="text" placeholder="Enter Name" />
              </div>
            </div>
            {/* 4 */}
            <div className="row mt-2">
              <div className="col-sm-3">
                <label style={{ padding: 0, margin: 0, color: "black" }}>
                  Travel Type:
                </label>
                <select
                  name="Any Theme"
                  id="Any Theme"
                  style={{ width: "100%", height: "2em" }}
                >
                  <option value="beach">Sector</option>
                  <option value="saab">Saab</option>
                  <option value="opel">Opel</option>
                  <option value="audi">Audi</option>
                </select>
              </div>

              <div className="col-sm-3">
                <label style={{ padding: 0, margin: 0, color: "black" }}>
                  Travel Date:
                </label>
                <input
                  type="date"
                  placeholder="Select Travel Date"
                  style={{ width: "100%" }}
                />
              </div>
              <div className="col-sm-3">
                <label style={{ padding: 0, margin: 0, color: "black" }}>
                  Duration:
                </label>
                <select
                  name="Any Theme"
                  id="Any Theme"
                  style={{ width: "100%", height: "2em" }}
                >
                  <option value="beach">Sector</option>
                  <option value="saab">Saab</option>
                  <option value="opel">Opel</option>
                  <option value="audi">Audi</option>
                </select>
              </div>
              <div className="col-sm-3">
                <label style={{ padding: 0, margin: 0, color: "black" }}>
                  Person(s):
                </label>
                <select
                  name="Any Theme"
                  id="Any Theme"
                  style={{ width: "100%", height: "2em" }}
                >
                  <option value="beach">Sector</option>
                  <option value="saab">Saab</option>
                  <option value="opel">Opel</option>
                  <option value="audi">Audi</option>
                </select>
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-sm-12">
                <label style={{ padding: 0, margin: 0, color: "black" }}>
                  More:
                </label>
                <textarea
                  className="form-control"
                  id="exampleFormControlTextarea1"
                  rows="3"
                ></textarea>
              </div>
            </div>
          </form>
        </div>
        <div
          // class="modal-footer"
          style={{ display: "flex", justifyContent: "center", margin: 5 }}
        >
          <button
            type="button"
            style={{
              backgroundColor: "#286090",
              borderRadius: "5px",
              borderColor: "#286090",
              color: "white",
            }}
          >
            Submit
          </button>
        </div>
      </Box>
    </Modal>
  );
};

export default ContactModalComponent;
